import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=f3b8cc72&scoped=true&"
import script from "./RolesList.vue?vue&type=script&lang=js&"
export * from "./RolesList.vue?vue&type=script&lang=js&"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=f3b8cc72&lang=scss&scoped=true&"
import style1 from "./RolesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b8cc72",
  null
  
)

export default component.exports